// extracted by mini-css-extract-plugin
module.exports = {"content":"style__content__z4Rqn"};